export default __webpack_public_path__ + "static/Ulm-Grotesk-Regular-84bd35d45a45c30f5ccd1001d932bcb5.otf";